import type { IContactPreferredContactMethod } from './ContactPreferredContactMethod.interface';

export default class ContactPreferredContactMethod implements IContactPreferredContactMethod {
  phone: boolean;
  email: boolean;

  static build = (data: IContactPreferredContactMethod) =>
    new ContactPreferredContactMethod(data);

  static blank = () => new ContactPreferredContactMethod();

  /**
   * Constructor
   * @param {IContactPreferredContactMethod} data
   */
  constructor(data?: IContactPreferredContactMethod) {
    this.phone = data?.phone === true;
    this.email = data?.email === true;
  }
}
